export class EditVendorItemIgnoreRequest {

    ID: number;
    Ignore: boolean;

}